import {clearGroup} from "../sceneManager";
import {wallDirectionAxis} from "../models/walls/wallGeneration";
import {BufferGeometry, Line, Vector3} from "three";
import {tmpGroup} from "../main";
import {setObjectLayer} from "./layerUtils";
import * as Globals from "../globals";
import {dashedlineMaterial} from "../constants/materialConstants";

let currentAxis = [];

export function removeVisualAxis() {
    //Remove old axis
    if (currentAxis === undefined) {
        return;
    }
    for (let i = 0; i < currentAxis.length; i++) {
        clearGroup(currentAxis[i]);
        currentAxis[i].removeFromParent();
    }
    currentAxis = [];
}

export function addVisualAxis(closestPoint, axis = null) {
    //Insert new axis if a snap point was found
    if (closestPoint !== null) {
        let startPoint, endPoint;
        if (axis === wallDirectionAxis.xAxis) {
            startPoint = new Vector3(closestPoint.x, 4, -100);
            endPoint = new Vector3(closestPoint.x, 4, 100);
        } else if (axis === wallDirectionAxis.zAxis) {
            startPoint = new Vector3(-100, 4, closestPoint.z);
            endPoint = new Vector3(100, 4, closestPoint.z);
        }

        let geometry = new BufferGeometry().setFromPoints([startPoint, endPoint]);
        let line = new Line(geometry, dashedlineMaterial);
        line.computeLineDistances();
        setObjectLayer(line, Globals.layers.layoutViewOnly);
        line.material = dashedlineMaterial;
        currentAxis.push(line);
        tmpGroup.addWithUuid(line);
    }
}
